export default "__VITE_ASSET__BL8Po4Yw__"